<template>
	<div class="right display-flex flex-column flex-justify-space-between">
		<div class="top">
			<IdeaMainButton :idea="idea" @idea-saved="ideaSaved" />
			<UpVotersAvatarGroup :numToShow="9" :idea="idea" v-if="isIdeaSavedToAccount" class="mt-3" />
			<TeamsLikedSpan class="mt-5" v-else :numOfTeams="idea.number_of_accounts_idea_is_in" :ideaId="idea.id" />
		</div>
		<div class="bottom">
			<GetHelpBuildingIdea :idea="idea" class="mb-3" extended />
			<h3 @click="openDeleteIdeaDialog" v-if="isIdeaSavedToAccount" class="archive reg py-2 mt-2">
				<SIcon name="archive-idea" class="mr-1" :width="14" :height="14" /> Archive
			</h3>
		</div>
	</div>
</template>
<script>
import { mapActionsShorthand } from '@/store/utils/mappers';
import { archiveIdea } from '@/store/modules/inspirationCenter/actions';
import TeamsLikedSpan from '@/components/InspirationCenter/TeamsLikedSpan.vue';
import IdeaMainButton from '@/components/InspirationCenter/IdeaMainButton.vue';
import UpVotersAvatarGroup from '@/components/InspirationCenter/UpVotersAvatarGroup.vue';
import GetHelpBuildingIdea from '@/components/dialogs/IdeaDialog/GetHelpBuildingIdea.vue';
import InspirationCenterService from '@/components/InspirationCenter/inspiration-center-service';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { APP_CONFIRMATION_DIALOG_RESPONSES } from '@/components/dialogs/AppDialogs/app-confirmation-dialog.const.js';
export default {
	name: 'IdeaDialogRightSide',
	components: { IdeaMainButton, TeamsLikedSpan, UpVotersAvatarGroup, GetHelpBuildingIdea },
	props: { idea: { type: Object } },
	computed: {
		isIdeaSavedToAccount() {
			return InspirationCenterService.isIdeaSavedToAccount(this.idea);
		},
	},
	methods: {
		...mapActionsShorthand({ archiveIdea }),
		async openDeleteIdeaDialog() {
			const dialogProps = {
				title: 'Are you sure you want to archive this idea?',
				description: 'This action is irreversible.',
				yesText: 'Archive',
				noText: 'Cancel',
			};
			const res = await AppDialogManagerService.openConfirmationDialog(dialogProps);
			if (res === APP_CONFIRMATION_DIALOG_RESPONSES.YES) {
				await this.archiveIdea({ ideaId: this.idea.id });
				this.$emit('close');
			}
		},
		ideaSaved() {
			this.$emit('idea-saved');
		},
	},
};
</script>

<style scoped lang="scss">
.right {
	background: #f7f7f9;
	padding: 28px 14px 0 14px;
}
.archive {
	cursor: pointer;
	color: #4d4c52;
	letter-spacing: 0px;
	border-top: 1px solid #e7e7ec;
}
</style>
